import { useState } from "react";
import { uploadImageToGhl } from "hook/services";
import toast from "react-hot-toast";

const useImageUpload = (agency, imageSetters) => {
  const [cropModalOpen, setCropModalOpen] = useState(false);
  const [currentImage, setCurrentImage] = useState(null);
  const [tempFile, setTempFile] = useState(null);
  const [activeType, setActiveType] = useState(null);

  const handleImageUpload = (e, type) => {
    const file = e.target.files?.[0];
    if (file) {
      const localUrl = URL.createObjectURL(file);
      setTempFile(file);
      setActiveType(type);
      setCurrentImage(localUrl);
      setCropModalOpen(true);

      // Instant preview
      if (imageSetters && imageSetters[type]?.setPreview) {
        imageSetters[type].setPreview(localUrl);
      }
    }
    // Reset input value so same file can be selected again
    if (e.target) {
      e.target.value = "";
    }
  };

  const handleImageClick = (url, type) => {
    if (url) {
      // Reset tempFile when opening crop modal with existing image
      setTempFile(null);
      setActiveType(type);
      setCurrentImage(url);
      setCropModalOpen(true);
    }
  };

  const handleCropComplete = async (croppedBlob) => {
    if (!croppedBlob) return;

    try {
      let fileToUpload;
      if (tempFile) {
        fileToUpload = new File([croppedBlob], tempFile.name, { type: tempFile.type });
      } else {
        fileToUpload = new File([croppedBlob], `${activeType}.jpg`, { type: "image/jpeg" });
      }

      // Instant preview with blob URL
      if (imageSetters && imageSetters[activeType]?.setPreview) {
        const blobUrl = URL.createObjectURL(croppedBlob);
        imageSetters[activeType].setPreview(blobUrl);
      }

      const uploadedUrl = await uploadImageToGhl(fileToUpload, agency);

      if (uploadedUrl?.success && uploadedUrl?.data) {
        if (imageSetters && imageSetters[activeType]) {
          const { setImage, setPreview } = imageSetters[activeType];
          if (setImage) setImage(uploadedUrl.data);
          if (setPreview) setPreview(uploadedUrl.data);
        }
        toast.success("Image uploaded successfully");
      } else {
        console.error("Image upload failed:", uploadedUrl);
        toast.error("Image upload failed");
      }
    } catch (err) {
      console.error("Image upload failed:", err);
      toast.error("Image upload failed");
    } finally {
      setCropModalOpen(false);
      setTempFile(null);
      setActiveType(null);
    }
  };

  const closeCropModal = () => {
    setCropModalOpen(false);
    setTempFile(null);
    setActiveType(null);
  };

  const getAspectRatio = () => {
    if (activeType === "main_image") return 3.8 / 1;
    if (activeType === "img_1") return 2 / 1;
    return 0;
  };

  return {
    cropModalOpen,
    currentImage,
    activeType,
    handleImageUpload,
    handleImageClick,
    handleCropComplete,
    closeCropModal,
    getAspectRatio,
  };
};

export default useImageUpload;
